.simpleSlideshow {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 100%;
  .simpleSlideshow-image {
    position: absolute;
    top: 0;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.5s, filter 0.5s;
    z-index: 2;
    filter: blur(5px);
    &.simpleSlideshow-show {
      opacity: 1;
      z-index: 1;
      filter: blur(0px);
    }
  }
}
